import { render, staticRenderFns } from "./MostActedAlarms.vue?vue&type=template&id=a4882362&scoped=true&"
import script from "./MostActedAlarms.vue?vue&type=script&lang=js&"
export * from "./MostActedAlarms.vue?vue&type=script&lang=js&"
import style0 from "./MostActedAlarms.vue?vue&type=style&index=0&id=a4882362&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4882362",
  null
  
)

export default component.exports